import React, { useEffect, useState } from 'react';
import MyLockedItem from './MyLockedItem';
import styled from 'styled-components';
import NoData from 'Components/NoData';
import { useSelector } from 'react-redux';
import { LIST_POOL } from '__mocks__/PackageData';
import store from 'store/index';
import { getStakerInfoV2 } from 'store/actions';

const StyledWrap = styled.div`
  width: 100%;
  overflow: auto;
`;
const THItem = styled.th`
  padding: 10px 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: none;
  font-family: inherit;
  margin-left: 20px;
  color: #fff;
`;

const StyledHeadingTR = styled.tr`
  background-color: var(--card-color);
  height: 50px;
  border-radius: 6px;
`;

const StyledTable = styled.table`
  width: 100%;
  border: 2px solid var(--card-color);
  overflow: auto;
  border-radius: 6px;
`;

export default function MyLockedStaking() {
  const { walletAddress } = useSelector((state) => state);
  const [stakes, setStakes] = useState([]);
  const [isLoading, setLoading] = useState(false);

  async function getUserStakeInfo() {
    setLoading(true);
    const listStakedPools = await Promise.all(
      LIST_POOL.map(async (poolPackage) => {
        const histories = await store.dispatch(getStakerInfoV2(poolPackage.abi, poolPackage.contractFarm));
        const historiesData = histories.map((history) => {
          const { amount, isRelease, releaseDate, rewardDebt, termOption, apr } = history;
          return {
            amount,
            isRelease,
            releaseDate,
            rewardDebt,
            termOption,
            contractFarm: poolPackage.contractFarm,
            contractToken: poolPackage.contractToken,
            apr
          };
        });
        return historiesData;
      })
    );
    setLoading(false);
    try {
      const res = listStakedPools.map((listOfStaked) => {
        return listOfStaked.map((stake, indexStake) => {
          return {
            ...stake,
            indexStake,
            isStaked: false,
          };
        })
        .filter((stake) => !stake.isRelease);
      })
      const listOfStaked2 = res.reduce((a, b) => a.concat(b))
      setStakes(listOfStaked2 ?? []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    if (!walletAddress) return;
    getUserStakeInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletAddress]);

  const updateStaked = (indexStake) => {
    const newStakes = stakes.slice() ?? [];

    setStakes(
      newStakes.map((stake) => {
        if (stake.indexStake === indexStake) {
          return {
            ...stake,
            isStaked: true,
          };
        } else {
          return stake;
        }
      })
    );
  };

  return (
    <StyledWrap>
      <StyledTable>
        <thead>
          <StyledHeadingTR>
            <THItem>Package</THItem>
            <THItem>Total Amount</THItem>
            <THItem>APR</THItem>
            <THItem>Stake Date</THItem>
            <THItem>Locked Days</THItem>
            <THItem>Interest End Date</THItem>
            <THItem>Estimated Interests</THItem>
            <THItem></THItem>
          </StyledHeadingTR>
        </thead>

        {stakes.length > 0 ? (
          <tbody>
            {stakes.map((stake, index) => {
              return <MyLockedItem key={index} stake={stake} updateStaked={updateStaked} isLoading={isLoading} setLoading={setLoading} />;
            })}
          </tbody>
        ) : (
          <tbody></tbody>
        )}
      </StyledTable>
      {stakes.length > 0 ? null : (
        <div>
          <NoData />
        </div>
      )}
    </StyledWrap>
  );
}
